import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResetPasswordRequestBody = {
  domain: string;
  user: {
    email: string;
  };
};

export const requestResetPassword = async ({ body }: BodyRequest<ResetPasswordRequestBody>) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.user.password, body, { skipAuth: true });
